export const RESET = "RESET";
export const SET_LOADING = "SET_LOADING";
export const APPLY_FILTER = "APPLY_FILTER";

export const INITIAL_STATE = {
    isLoading: false,
};

export function reducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case RESET:
            return INITIAL_STATE;
        case APPLY_FILTER:
            return {...state, filter: action.payload.filter};
        case SET_LOADING:
            const isLoading = action.payload.isLoading;
            return {...state, isLoading: isLoading };
        case "SUBSCRIPTION_DATA_ARRIVED/EXPLORE_CUSTOM_GROUPING":
            const payload = action.payload;
            return {...state, ...payload, failure: null, isLoading: false};
        case "SUBSCRIPTION_DATA_FAILED/EXPLORE_CUSTOM_GROUPING":
            return {...state, failure: action.payload, isLoading: false};
        default:
            return state;
    }
}

export default dispatch => ({
    setLoading(isLoading) {
        dispatch({type: SET_LOADING, payload: {isLoading}});
    },
    reset() {
        dispatch({type: RESET});
    },
    applyFilter(filter) {
        dispatch({type: APPLY_FILTER, payload: {filter}})
    }
});
